import { Link } from 'react-router-dom';

interface ArticlePreview {
  id: number;
  title: string;
  category: string;
  description: string;
  path: string;
  image: string;
  imageAlt: string;
  readTime: string;
}

const articlePreviews: ArticlePreview[] = [
  {
    id: 1,
    title: 'Ist OOPBUY sicher?',
    category: 'Sicherheit',
    description: 'Alles über OOPBUY Sicherheit, Verkäuferprüfung und wie du typische Risiken beim Spreadsheet Shopping vermeidest. Der komplette Sicherheitsguide 2026.',
    path: '/oopbuy-sicherheit',
    image: 'https://readdy.ai/api/search-image?query=modern%20security%20concept%20with%20shield%20and%20padlock%20on%20warm%20beige%20desk%2C%20soft%20natural%20lighting%2C%20minimalist%20photography%2C%20warm%20neutral%20tones%2C%20professional%20European%20tech%20aesthetic%2C%20clean%20composition&width=800&height=500&seq=preview-sicherheit&orientation=landscape',
    imageAlt: 'OOPBUY Sicherheit Guide',
    readTime: '6 Min.',
  },
  {
    id: 2,
    title: 'OOPBUY Versand nach Deutschland',
    category: 'Versand',
    description: 'Versandmethoden vergleichen, Lieferzeiten verstehen und Zollgebühren vermeiden. Der komplette OOPBUY Versand Guide für DACH.',
    path: '/oopbuy-versand',
    image: 'https://readdy.ai/api/search-image?query=cardboard%20shipping%20box%20with%20destination%20pin%20on%20warm%20beige%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20logistics%20photography%2C%20warm%20neutral%20tones%2C%20clean%20European%20aesthetic%2C%20ecommerce%20shipping%20concept&width=800&height=500&seq=preview-versand&orientation=landscape',
    imageAlt: 'OOPBUY Versand Guide',
    readTime: '5 Min.',
  },
  {
    id: 3,
    title: 'OOPBUY QC Guide',
    category: 'Qualitätskontrolle',
    description: 'QC-Bilder verstehen, gute Qualität erkennen und schlechte Produkte vermeiden. Werde zum QC-Profi.',
    path: '/oopbuy-qc-guide',
    image: 'https://readdy.ai/api/search-image?query=magnifying%20glass%20inspecting%20fabric%20detail%20on%20warm%20beige%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20quality%20inspection%20photography%2C%20warm%20neutral%20tones%2C%20clean%20professional%20aesthetic&width=800&height=500&seq=preview-qc&orientation=landscape',
    imageAlt: 'OOPBUY QC Guide',
    readTime: '5 Min.',
  },
  {
    id: 4,
    title: 'OOPBUY vs Alternativen',
    category: 'Vergleich',
    description: 'OOPBUY vs Pandabuy, Sugargoo und AllChinaBuy. Welcher China-Agent ist der beste für Spreadsheets?',
    path: '/oopbuy-vergleich',
    image: 'https://readdy.ai/api/search-image?query=side%20by%20side%20comparison%20cards%20on%20warm%20beige%20desk%20surface%2C%20soft%20natural%20daylight%2C%20minimalist%20comparison%20photography%2C%20warm%20neutral%20tones%2C%20clean%20professional%20European%20aesthetic&width=800&height=500&seq=preview-vergleich&orientation=landscape',
    imageAlt: 'OOPBUY Vergleich',
    readTime: '4 Min.',
  },
  {
    id: 5,
    title: 'OOPBUY für Anfänger',
    category: 'Einsteiger',
    description: 'Schritt für Schritt von der Registrierung bis zur ersten Bestellung. Der perfekte Guide für komplette Neueinsteiger.',
    path: '/oopbuy-anfaenger',
    image: 'https://readdy.ai/api/search-image?query=open%20notebook%20with%20pen%20and%20welcome%20concept%20on%20warm%20beige%20desk%2C%20soft%20natural%20lighting%2C%20minimalist%20beginner%20guide%20photography%2C%20warm%20neutral%20tones%2C%20fresh%20start%20aesthetic&width=800&height=500&seq=preview-anfaenger&orientation=landscape',
    imageAlt: 'OOPBUY Anfänger Guide',
    readTime: '5 Min.',
  },
  {
    id: 6,
    title: 'OOPBUY Trendprodukte 2026',
    category: 'Trends',
    description: 'Die angesagtesten Sneaker, Streetwear und Accessoires im Überblick. Das sind die Top-Trends im Spreadsheet.',
    path: '/oopbuy-trendprodukte',
    image: 'https://readdy.ai/api/search-image?query=curated%20trendy%20fashion%20accessories%20arranged%20on%20warm%20beige%20surface%2C%20soft%20natural%20lighting%2C%20modern%20lifestyle%20photography%2C%20warm%20neutral%20tones%2C%20aspirational%20aesthetic%2C%20clean%20composition&width=800&height=500&seq=preview-trend&orientation=landscape',
    imageAlt: 'OOPBUY Trendprodukte 2026',
    readTime: '4 Min.',
  },
  {
    id: 7,
    title: 'OOPBUY Verkäufer finden',
    category: 'Verkäufer',
    description: 'So erkennst du zuverlässige Anbieter. Bewertungen checken, QC prüfen und Community-Feedback nutzen.',
    path: '/oopbuy-verkaufer',
    image: 'https://readdy.ai/api/search-image?query=handshake%20and%20trust%20symbols%20on%20warm%20beige%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20business%20partnership%20photography%2C%20warm%20neutral%20tones%2C%20reliable%20vendor%20concept&width=800&height=500&seq=preview-verkaufer&orientation=landscape',
    imageAlt: 'OOPBUY Verkäufer finden',
    readTime: '4 Min.',
  },
  {
    id: 8,
    title: 'OOPBUY Kosten sparen',
    category: 'Sparen',
    description: '10 bewährte Spartipps für dein Spreadsheet Shopping. Versand optimieren und Sammelbestellungen clever nutzen.',
    path: '/oopbuy-kosten-sparen',
    image: 'https://readdy.ai/api/search-image?query=piggy%20bank%20with%20coins%20and%20savings%20notes%20on%20warm%20beige%20desk%2C%20soft%20natural%20lighting%2C%20minimalist%20savings%20photography%2C%20warm%20neutral%20tones%2C%20financial%20concept%2C%20clean%20aesthetic&width=800&height=500&seq=preview-sparen&orientation=landscape',
    imageAlt: 'OOPBUY Kosten sparen',
    readTime: '5 Min.',
  },
  {
    id: 9,
    title: 'OOPBUY FAQ Sammlung',
    category: 'FAQ',
    description: 'Die umfassendste FAQ-Sammlung im deutschen Sprachraum. Antworten auf alle wichtigen Spreadsheet Fragen.',
    path: '/oopbuy-faq',
    image: 'https://readdy.ai/api/search-image?query=question%20marks%20and%20organized%20answer%20cards%20on%20warm%20beige%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20FAQ%20concept%20photography%2C%20warm%20neutral%20tones%2C%20clean%20professional%20aesthetic&width=800&height=500&seq=preview-faq&orientation=landscape',
    imageAlt: 'OOPBUY FAQ',
    readTime: '7 Min.',
  },
];

export default function ArticlePreviews() {
  return (
    <section id="articles" className="relative py-16 md:py-24 px-4 md:px-12 lg:px-20 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-100 rounded-full border border-background-200/70 mb-5">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            <span className="text-foreground-600 text-xs font-medium whitespace-nowrap">SEO Artikel & Guides</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            OOPBUY Spreadsheet Wissen
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Experten-Guides und ausführliche Artikel rund um OOPBUY Spreadsheet, Sicherheit, Versand und mehr
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {articlePreviews.map((article) => (
            <Link
              key={article.id}
              to={article.path}
              className="group flex flex-col bg-white rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-400 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <div className="flex items-center gap-2 mb-2">
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-accent-100/80 text-accent-700 text-[11px] font-medium rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-foreground-400 text-[11px] whitespace-nowrap">{article.readTime}</span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-2 group-hover:text-accent-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2 flex-1">
                  {article.description}
                </p>
                <div className="flex items-center gap-1.5 mt-3 text-accent-600 text-xs font-medium whitespace-nowrap">
                  Weiterlesen
                  <span className="w-3.5 h-3.5 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}